///<reference path="../../../core/visbos-core/ui/components/abstract-list-view.ts"/>
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {FormArray, FormBuilder} from "@angular/forms";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {ProcurementService} from "../../services/procurement-service/procurement.service";
import {SessionActions} from "../../../shared/actions/session.actions";
import {AdministrationUnit} from "../../../shared/view-model/organization/administration-unit.type";
import {DispatchListItem} from "../../../shared/view-model/store-management/dispatch-list-item.type";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-dispatch-items-table',
  templateUrl: './dispatch-items-table.component.html',
  styleUrls: ['./dispatch-items-table.component.css']
})
export class DispatchItemsTableComponent extends AbstractListView implements OnInit, AfterViewInit, OnChanges {

  that;

  console;

  @Input()
  targetAdminUnit: AdministrationUnit;

  @Input()
  control: FormArray;

  @Input()
  dispatchItems: DispatchListItem[];


  @ViewChild('dispatchItemDetails')
  dispatchItemDetails: TemplateRef<any>;

  @ViewChild('editAmountTmpl')
  editAmountTmpl: TemplateRef<any>;

  @ViewChild('sourceStockTmpl')
  sourceStockTmpl: TemplateRef<any>;

  @ViewChild('packingUnitTmpl')
  packingUnitTmpl: TemplateRef<any>;

  @ViewChild('dispatchItemsTable')
  dispatchItemsTable: DatatableComponent;

  messages = {
    emptyMessage: 'Keine Artikel im Wareneingang vorhanden',
    totalMessage: 'Artikel im Wareneingang insgesamt'
  };

  constructor(private fb: FormBuilder,
              private procurementService: ProcurementService,
              sessionActions: SessionActions, cd: ChangeDetectorRef) {

    super(sessionActions, cd);

    this.that = this;

  }

  ngOnInit() {

    this.searchTerm = this.fb.control(null);

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'article_label', name: 'Artikel', minWidth: 250, flexGrow: 4},
      {name: 'Benötigt', minWidth: 50, maxWidth: 100, flexGrow: 1, sortable: false},
      {name: 'Bereits in Auslieferung', minWidth: 50, maxWidth: 100, flexGrow: 1},
      {name: 'Packmenge', cellTemplate: this.editAmountTmpl, minWidth: 50, maxWidth: 100, flexGrow: 1, sortable: false},
      {name: 'Einheit', cellTemplate: this.packingUnitTmpl, minWidth: 100, maxWidth: 150, flexGrow: 2, sortable: false},
      {name: 'Entnehmen aus', cellTemplate: this.sourceStockTmpl, minWidth: 100, maxWidth: 150, flexGrow: 2}
    ];

  }

  ngAfterViewInit(): void {

    super.ngAfterViewInit();
    this.cd.detectChanges();

    // Hack for ordering
    let col = this.dispatchItemsTable.table._columns[0];
    this.dispatchItemsTable.table.onColumnResize({column: col, newValue: 50});

    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.dispatchList) {
      this.rows = this.dispatchItems;
    }

  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.dispatchItems;
    } else {
      if (this.dispatchItems) {
        this.rows = this.dispatchItems.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row: any, res: any) {
    throw new Error("Method not implemented.");
  }

  onItemRemove(item) {

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/dispatch-items-table/dispatch-items-table.component.ts